import { Vue, Prop, Component, Inject } from 'nuxt-property-decorator';
import { FormFieldDto, FormFieldChoiceDto, isFieldChoiceAvailable, transl8 } from '../../services';

type ValidationRules = {
  required: boolean;
  email: boolean;
  minimum_one_presenter?: boolean;
};

@Component({
  // Remove redundant unit test warnings.
  template: '<p/>',
})
export default class AbstractInput extends Vue {
  @Inject() $validator;

  @Prop({ type: [Array, String] }) value!: string | string[];
  @Prop({ required: true }) field!: FormFieldDto;

  public innerValue: string | string[] = '';

  validationRules: ValidationRules = {
    required: this.field.isRequired,
    email: this.field.fieldType === 'email',
  };

  get description(): string {
    return transl8(this.field.description);
  }

  get validationErrors(): string | undefined {
    if (this.errors && this.errors.items && this.errors.items.some(e => e.field === this.field.id)) {
      return this.errors.items.find(x => x.field === this.field.id)?.msg;
    }
    return this.errors.first(this.field.id);
  }

  public created(): void {
    this.innerValue = this.value;
  }

  public isFieldChoiceAvailable(dto: FormFieldChoiceDto): boolean {
    return isFieldChoiceAvailable(dto);
  }
}
